module.exports = __webpack_public_path__ + "57daad0f9f4e3afa782071f7f923650c.svg";